import { Loader } from "./Loader";
import { Effect } from "./Effect";

export class Material {

    public effect: Effect;

    constructor(public reference: string) {

    }

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        let effectReference = dataView.getInt32(offset, true);
        offset += 4;

        this.effect = loader.getBlob<Effect>(effectReference);
    }

    public getImageReference(): string {

        if (this.effect.diffuse) {
            return this.effect.diffuse.reference;
        } else {
            return null;
        }

        // if (this.effect.images.length > 0) {
        //     return this.effect.images[0].reference;
        // } else {
        //     return null;
        // }
    }
}
